import React, { useEffect, useImperativeHandle, forwardRef, useRef } from 'react';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';

const MyEditor = forwardRef(({ setContent, initialContent }, ref) => {


    console.log(setContent,initialContent);
    
    const editorRef = useRef(null);
    const previousContentRef = useRef(initialContent); // Track the previous content

    // Expose SunEditor methods to the parent component
    useImperativeHandle(ref, () => ({
        setContents: (content) => {
            if (editorRef.current) {
                editorRef.current.setContents(content);
                focusEditor(); // Focus the editor after setting content
            }
        },
    }), []);

    // Set initial content when the component mounts or when initialContent changes
    useEffect(() => {
        if (editorRef.current && initialContent !== previousContentRef.current) {
            editorRef.current.setContents(initialContent);
            previousContentRef.current = initialContent; // Update the ref to the new content
            focusEditor(); // Focus the editor after setting content
        }
    }, [initialContent]);

    const handleChange = (content) => {
        // Only update content if it has changed
        if (content !== previousContentRef.current) {
            setContent(content); // Update parent component's content state
            previousContentRef.current = content; // Update the ref to the new content
        }
    };

    const focusEditor = () => {
        if (editorRef.current) {
            const editorInstance = editorRef.current.editor; // Get the internal editor instance
            if (editorInstance) {
                editorInstance.focus(); // Focus the editor
            }
        }
    };

    return (
        <SunEditor
            getSunEditorInstance={(sunEditor) => {
                editorRef.current = sunEditor; // Store the editor instance
            }}
            onChange={handleChange} // Trigger handleChange on content change
            height="500" // Adjust height as necessary
            setOptions={{
                buttonList: [
                    ['undo', 'redo', 'font', 'fontSize', 'formatBlock'],
                    ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'removeFormat'],
                    ['fontColor', 'hiliteColor', 'outdent', 'indent', 'align', 'horizontalRule', 'list', 'table'],
                    ['link', 'image', 'video', 'fullScreen', 'showBlocks', 'codeView', 'preview', 'print', 'save'],
                ],
            }}
        />
    );
});

export default MyEditor;
